var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMapMarkerCompany({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 8.75C17.25 10.53 16.67 12.27 15.59 13.69C15.59 13.69 15.36 13.99 15.33 14.03L9 21.5L2.67 14.04L2.41 13.7C1.33 12.27 0.75 10.53 0.75 8.75C0.76 4.19 4.45 0.5 9 0.5C13.55 0.5 17.25 4.19 17.25 8.75Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.97 7.85997V5.23997C10.97 4.87997 10.68 4.58997 10.32 4.58997H5.07999C4.71999 4.58997 4.42999 4.87997 4.42999 5.23997V13.75H13.6V8.50997C13.6 8.14997 13.31 7.85997 12.95 7.85997H10.97ZM6.94999 12.35H5.96999V10.71H6.94999V12.35ZM6.94999 9.98997H5.96999V8.34997H6.94999V9.98997ZM6.94999 7.62997H5.96999V5.98997H6.94999V7.62997ZM9.40999 12.35H8.42999V10.71H9.40999V12.35ZM9.40999 9.98997H8.42999V8.34997H9.40999V9.98997ZM9.40999 7.62997H8.42999V5.98997H9.40999V7.62997ZM12.93 13.1H10.97V8.51997H12.93V13.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMapMarkerCompany);
export default __webpack_public_path__ + "static/media/ic-map-marker-company.6317ebd195cc0091e39b4711703dcb58.svg";
export { ForwardRef as ReactComponent };